/* eslint-ignore */
// @ts-nocheck
import styled from "styled-components";

import { Link } from "react-router-dom";

export const TooltipContainer = styled.div`
  width: 342px;
  background: #97f8fb;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  color: #0b29fb;
  opacity: 0;
  transition: opacity 0.4s;
  visibility: hidden;

  top: 50%;
  left: 45px;
  transform: translateY(-50%);
  max-height: 86px;

  &::before {
    content: "";
    border-style: solid;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #97f8fb;
    border-left: none;
  }
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  width: 350px;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);

  &:hover ${TooltipContainer} {
    opacity: 1;
    visibility: visible;
  }
`;

export const TootipTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #0b29fb;
  text-align: initial;
  display: block;
  margin-bottom: 5px;
`;

export const TolltipItens = styled.span`
  text-align: initial;
`;

export const TooltipFormated = styled(Link)`
  text-decoration: underline;
  margin-left: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #0b29fb;
`;
